import React, { useState } from 'react';
import { ExternalLink, Info } from 'lucide-react';
import { motion } from 'framer-motion';
import { SelectDropdown } from './SelectDropdown';
const FREQUENCY_OPTIONS = [{
  value: 'daily',
  label: 'Daily'
}, {
  value: 'weekly',
  label: 'Weekly'
}, {
  value: 'immediately',
  label: 'Immediately'
}];
export function SettingsPanels() {
  // Notification Settings State
  const [notificationScope, setNotificationScope] = useState('account');
  const [gradingWeb, setGradingWeb] = useState(true);
  const [gradingEmail, setGradingEmail] = useState(true);
  const [gradingFrequency, setGradingFrequency] = useState('daily');
  const [updatesWeb, setUpdatesWeb] = useState(true);
  const [updatesEmail, setUpdatesEmail] = useState(false);
  const [updatesFrequency, setUpdatesFrequency] = useState('daily');
  const [activityWeb, setActivityWeb] = useState(true);
  const [activityEmail, setActivityEmail] = useState(true);
  const [activityFrequency, setActivityFrequency] = useState('daily');
  const [newQuestionWeb, setNewQuestionWeb] = useState(false);
  const [newQuestionEmail, setNewQuestionEmail] = useState(false);
  const [newQuestionFrequency, setNewQuestionFrequency] = useState('daily');
  const [newDiscussionWeb, setNewDiscussionWeb] = useState(false);
  const [newDiscussionEmail, setNewDiscussionEmail] = useState(false);
  const [newDiscussionFrequency, setNewDiscussionFrequency] = useState('daily');
  return <div data-phoebe-tour="settings" className="space-y-6" data-id="element-1612" data-mp="2yt9xscs1uyus">
      {/* Notifications Section */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-1613" data-mp="32tk5puzejzca">
        <div className="p-6 border-b border-gray-200" data-id="element-1614" data-mp="3ckohymxp163f">
          <h2 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1615" data-mp="2f2ekt1elugv4">Notifications</h2>
          <div className="text-sm text-gray-600 space-y-2" data-id="element-1616" data-mp="2k1r9lrp1dy0c">
            <p data-id="element-1617" data-mp="2k06dvyqzk90w">
              Account-level settings apply to all courses. Notifications for
              individual courses can be changed within each course and will
              override account-level settings.
            </p>
            <p data-id="element-1618" data-mp="vxu5t24wc0">
              Daily notifications are delivered at 22:00 UTC. Weekly
              notifications are delivered at 22:00 UTC Every Sunday.
            </p>
            <p className="text-[#30718D]" data-id="element-1619" data-mp="3s6j4yvedagvp">
              Notifications for certain activities are enabled by default,{' '}
              <a href="#" className="underline hover:text-[#265a70]" data-id="element-1620" data-mp="2zg129vhk2hit">
                as detailed here
              </a>
              <ExternalLink size={12} className="inline ml-1" data-id="element-1621" data-mp="3dgbsqxeydu3g" />
            </p>
          </div>
        </div>

        <div className="p-6" data-id="element-1622" data-mp="38fee2ut5ji6p">
          {/* Notification Scope Selector */}
          <div className="mb-6" data-id="element-1623" data-mp="so8n4nqlri90">
            <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1624" data-mp="sngrjcx09kiq">
              Select notifications for
            </label>
            <SelectDropdown fullWidth ariaLabel="Select notifications for" value={notificationScope} onChange={setNotificationScope} options={[{
            value: 'account',
            label: 'Account'
          }, {
            value: 'course1',
            label: 'Course 1'
          }, {
            value: 'course2',
            label: 'Course 2'
          }]} data-id="element-1625" data-mp="w6z3ijlhc4ua" />
            <p className="text-xs text-gray-500 mt-1" data-id="element-1626" data-mp="r84kbgjloe9n">Applies to all courses</p>
          </div>

          {/* Notification Settings Table */}
          <div className="space-y-6" data-id="element-1627" data-mp="1jwa3vzyx3x7w">
            {/* Grading */}
            <div data-id="element-1628" data-mp="1jymjw7l47xib">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1629" data-mp="157nfz9v85x52">Grading</h3>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1630" data-mp="155jc2rxbsy4s">
                <div className="flex-1" data-id="element-1631" data-mp="1xwky9czfrtxt">
                  <span className="text-sm text-gray-700" data-id="element-1632" data-mp="1xvjdggsmbt2w">
                    Essay assignment grade received
                  </span>
                </div>
                <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1633" data-mp="e0yqjuzmaqcd">
                  <div className="flex items-center gap-2" data-id="element-1634" data-mp="dyvq0h0u9ete">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1635" data-mp="9yttem9ynbkz">
                      Web
                    </span>
                    <button onClick={() => setGradingWeb(!gradingWeb)} aria-label="Toggle web notifications for essay assignment grades" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1636" data-mp="52mqz3grwi7s">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1637" data-mp="sqmocm8lb6vc" />
                    </button>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1638" data-mp="iy76doxamiag">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1639" data-mp="1ggqqsqa1l0kr">
                      Email
                    </span>
                    <button onClick={() => setGradingEmail(!gradingEmail)} aria-label="Toggle email notifications for essay assignment grades" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1640" data-mp="1bnntc72596za">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1641" data-mp="1swq64e0n2ehi" />
                    </button>
                  </div>
                  <SelectDropdown size="sm" menuAlign="right" ariaLabel="Essay assignment grade received notification frequency" value={gradingFrequency} onChange={setGradingFrequency} options={FREQUENCY_OPTIONS} data-id="element-1642" data-mp="21wwpuhmxkap4" />
                </div>
              </div>
            </div>

            {/* Updates */}
            <div data-id="element-1643" data-mp="2gpyi7uybrw4z">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1644" data-mp="2lmytcka17p2y">Updates</h3>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1645" data-mp="2lkvtz9mzojlk">
                <div className="flex-1" data-id="element-1646" data-mp="qjk6ubw0dzag">
                  <span className="text-sm text-gray-700" data-id="element-1647" data-mp="qkliahgxsnsp">Course updates</span>
                </div>
                <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1648" data-mp="lmab6ei10re6">
                  <div className="flex items-center gap-2" data-id="element-1649" data-mp="zcduoxpiu6zx">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1650" data-mp="ulf9bjpoeipt">
                      Web
                    </span>
                    <button onClick={() => setUpdatesWeb(!updatesWeb)} aria-label="Toggle web notifications for course updates" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1651" data-mp="199iguxjda2gq">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1652" data-mp="1i8napqjzh7mk" />
                    </button>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-1653" data-mp="3g116eit6swld">
                    <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1654" data-mp="3g2ubvus2dars">
                      Email
                    </span>
                    <button onClick={() => setUpdatesEmail(!updatesEmail)} aria-label="Toggle email notifications for course updates" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1655" data-mp="39y6afuqnsu19">
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1656" data-mp="313zwcmsw30di" />
                    </button>
                  </div>
                  <SelectDropdown size="sm" menuAlign="right" ariaLabel="Course updates notification frequency" value={updatesFrequency} onChange={setUpdatesFrequency} options={FREQUENCY_OPTIONS} data-id="element-1657" data-mp="2d85f1cvsbfaz" />
                </div>
              </div>
            </div>

            {/* Discussions */}
            <div data-id="element-1658" data-mp="bexv1q5889ir">
              <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-1659" data-mp="gflqco0hncis">
                Discussions
              </h3>
              <div className="space-y-3" data-id="element-1660" data-mp="1p0kgh801wn7g">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1661" data-mp="1p2f26oj5cjcl">
                  <div className="flex-1 flex items-center gap-2" data-id="element-1662" data-mp="1fa9brj8jm9zi">
                    <span className="text-sm text-gray-700" data-id="element-1663" data-mp="1f8oe3kqxmaxf">
                      Activity notifications
                    </span>
                    <Info size={14} className="text-gray-400" data-id="element-1664" data-mp="169jk8rqbf5rl" />
                  </div>
                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1665" data-mp="11aq4esnk32o9">
                    <div className="flex items-center gap-2" data-id="element-1666" data-mp="11ct3e26os654">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1667" data-mp="wcoky6m7x1c9">
                        Web
                      </span>
                      <button onClick={() => setActivityWeb(!activityWeb)} aria-label="Toggle web notifications for discussion activity" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1668" data-mp="sc4qjat14btt">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1669" data-mp="8figr25qm386" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1670" data-mp="i87rfutgrd2g">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1671" data-mp="m6eyfxy4l00g">
                        Email
                      </span>
                      <button onClick={() => setActivityEmail(!activityEmail)} aria-label="Toggle email notifications for discussion activity" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1672" data-mp="3lowngmvf74dv">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1673" data-mp="3iidez09vekr" />
                      </button>
                    </div>
                    <SelectDropdown size="sm" menuAlign="right" ariaLabel="Activity notifications frequency" value={activityFrequency} onChange={setActivityFrequency} options={FREQUENCY_OPTIONS} data-id="element-1674" data-mp="3x0d6ukjfp76" />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-1675" data-mp="dnv1e4hcgyv9">
                  <div className="flex-1" data-id="element-1676" data-mp="il3ie1qrawux">
                    <span className="text-sm text-gray-700" data-id="element-1677" data-mp="3h42345g78m1e">
                      New question posts
                    </span>
                  </div>
                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1678" data-mp="3m2vjc5mver59">
                    <div className="flex items-center gap-2" data-id="element-1679" data-mp="3r0x20pgdwog7">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1680" data-mp="3v31on48f0ktc">
                        Web
                      </span>
                      <button onClick={() => setNewQuestionWeb(!newQuestionWeb)} aria-label="Toggle web notifications for new question posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1681" data-mp="16apiqsiv7i4i">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1682" data-mp="2qt9u8fcvnrf2" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1683" data-mp="2h36yi7edfzd1">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1684" data-mp="2c4vr03bju0xz">
                        Email
                      </span>
                      <button onClick={() => setNewQuestionEmail(!newQuestionEmail)} aria-label="Toggle email notifications for new question posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1685" data-mp="2747p2mls7zoz">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1686" data-mp="1c2e1d68o30v" />
                      </button>
                    </div>
                    <SelectDropdown size="sm" menuAlign="right" ariaLabel="New question posts notification frequency" value={newQuestionFrequency} onChange={setNewQuestionFrequency} options={FREQUENCY_OPTIONS} data-id="element-1687" data-mp="fg9oklcd8keh" />
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 gap-3" data-id="element-1688" data-mp="bhaphhdbfhuy">
                  <div className="flex-1" data-id="element-1689" data-mp="z7enn97qipek">
                    <span className="text-sm text-gray-700" data-id="element-1690" data-mp="137oueo3cpjuh">
                      New discussion posts
                    </span>
                  </div>
                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-1691" data-mp="p74f41wna65q">
                    <div className="flex items-center gap-2" data-id="element-1692" data-mp="u5xrfr073r4b">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1693" data-mp="39y4v06zesllu">
                        Web
                      </span>
                      <button onClick={() => setNewDiscussionWeb(!newDiscussionWeb)} aria-label="Toggle web notifications for new discussion posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1694" data-mp="3ey9bhx0bhgc2">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1695" data-mp="3gen4oswa0thn" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-1696" data-mp="2nq93y5dszj2e">
                      <span className="text-xs font-medium text-gray-500 w-8" data-id="element-1697" data-mp="2jonuyv4e3oxh">
                        Email
                      </span>
                      <button onClick={() => setNewDiscussionEmail(!newDiscussionEmail)} aria-label="Toggle email notifications for new discussion posts" className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-1698" data-mp="2xh3w1qdqdcvr">
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-1699" data-mp="1zzlsxb8lcdbm" />
                      </button>
                    </div>
                    <SelectDropdown size="sm" menuAlign="right" ariaLabel="New discussion posts notification frequency" value={newDiscussionFrequency} onChange={setNewDiscussionFrequency} options={FREQUENCY_OPTIONS} data-id="element-1700" data-mp="2nl1qk15yy52w" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}